var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1101"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1101"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34030",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};